class TdfProductMediaDecor extends HTMLElement {
  #badge = null;

  connectedCallback() {
    const media = this.closest('product-component')?.querySelector('.product-information__media');
    if (!media) return;

    const background = this.dataset.background;
    if (background) media.style.setProperty('--tdf-media-bg', background);

    this.#detectCutout(media);

    media.querySelectorAll(':scope > .tdf-pdp-badge').forEach((node) => node.remove());
    const text = this.dataset.badge;
    if (!text) return;

    this.#badge = document.createElement('div');
    this.#badge.className = 'tdf-badge-round tdf-pdp-badge';
    this.#badge.textContent = text;
    media.append(this.#badge);
  }

  // Solo le immagini con bordi trasparenti (scontornate) possono sporgere dal riquadro colorato.
  // Si guardano i pixel, non l'estensione; se la lettura fallisce l'immagine resta dentro il box.
  #detectCutout(media) {
    const first = media.querySelector('.product-media-container img');
    const src = first?.currentSrc || first?.src;
    if (!src) return;
    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = () => {
      try {
        const scale = Math.min(1, 256 / Math.max(probe.naturalWidth, probe.naturalHeight));
        const w = Math.max(3, Math.round(probe.naturalWidth * scale));
        const h = Math.max(3, Math.round(probe.naturalHeight * scale));
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return;
        context.drawImage(probe, 0, 0, w, h);
        const alphaAt = (x, y) => context.getImageData(x, y, 1, 1).data[3];
        const edge = [];
        for (let x = 0; x < w; x++) edge.push([x, 0], [x, h - 1]);
        for (let y = 0; y < h; y++) edge.push([0, y], [w - 1, y]);
        const transparent = edge.filter(([x, y]) => alphaAt(x, y) <= 8).length;
        // Un prodotto scontornato può toccare il bordo alto/basso, ma gli angoli restano vuoti.
        const corners = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]].every(([x, y]) => alphaAt(x, y) <= 8);
        media.classList.toggle('tdf-media-cutout', corners && transparent / edge.length > 0.5);
      } catch {
        // Pixel non leggibili: nessuna sporgenza.
      }
    };
    probe.src = src;
  }

  disconnectedCallback() {
    this.#badge?.remove();
    this.#badge = null;
  }
}

if (!customElements.get('tdf-product-media-decor')) {
  customElements.define('tdf-product-media-decor', TdfProductMediaDecor);
}
